module.exports = __webpack_public_path__ + "static/media/call-to-action-bg.30a76d5d.jpg";